Jelly.Handlers.Document_Scroll = function (event)
{
	// Call handlers functions for document level scroll.
	
	// Hide Flash Uploaders
	// TODO: Can't build a more reliable mouseleave function :/
	//	Jelly.Files.Hide_Flash_Uploaders();
};